import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

/**
 * Shown after a restricted-domain submission has been received and stored.
 * The lead is captured; the report is simply not handed over.
 */
const RestrictedAccessModal = ({ open, onClose, message }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="restricted-access-title"
        className="bg-white rounded-xl shadow-lg max-w-md w-full"
      >
        <div className="flex justify-end px-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="px-8 pb-8 pt-1 text-center">
          <h3 id="restricted-access-title" className="text-lg font-semibold text-gray-800 mb-3">
            Download not available
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">{message}</p>
          <button
            type="button"
            onClick={onClose}
            className="mt-6 inline-flex justify-center py-2 px-8 rounded-md shadow-sm text-sm font-medium text-white bg-[#bc8b20] hover:bg-[#d6b15f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#c59c40] transition-colors duration-200"
          >
            Close
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default RestrictedAccessModal;
